var map = {
	"./default.svg": "./src/images/cursors/BLURRED/default.svg",
	"./hover.svg": "./src/images/cursors/BLURRED/hover.svg",
	"./preview_1.svg": "./src/images/cursors/BLURRED/preview_1.svg",
	"./preview_2.svg": "./src/images/cursors/BLURRED/preview_2.svg",
	"./project_hover_1.svg": "./src/images/cursors/BLURRED/project_hover_1.svg",
	"./project_hover_2.svg": "./src/images/cursors/BLURRED/project_hover_2.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/cursors/BLURRED sync recursive ^\\.\\/.*\\.svg$";